import React from 'react';
import SettingsLayout from './components/SettingsLayout';
import './styles.css';

const Settings = () => {
    return (
        <SettingsLayout />
    );
};

export default Settings;
